module.exports = __webpack_public_path__ + "static/media/icon-calendar.f3dd5023.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-calendar.svg
// module id = 863
// module chunks = 7